import t from './actionTypes'

const loginActions = {
	sendLoginForm(values, resolve, reject) {
		return {
			type: t.LOGIN_SEND_FORM,
			values,
			resolve,
			reject,
		}
	},
	resetLoginAuthentication() {
		return {
			type: t.LOGIN_RESET_AUTHENTICATION,
		}
	},
	sendForgotPasswordForm(values, resolve, reject) {
		return {
			type: t.LOGIN_SEND_FORGOT_PASSWORD_FORM,
			values,
			resolve,
			reject,
		}
	},
	validateNewPasswordRecoveryKey(key) {
		return {
			type: t.LOGIN_VALIDATE_RECOVERY_KEY,
			key,
		}
	},
	sendNewPasswordForm(values, resolve, reject) {
		return {
			type: t.LOGIN_SEND_NEW_PASSWORD_FORM,
			values,
			resolve,
			reject,
		}
	},
	navigateToSignUp() {
		return {
			type: t.LOGIN_NAVIGATE_TO_SIGNUP,
		}
	},
	navigateToLogin() {
		return {
			type: t.LOGIN_NAVIGATE_TO_LOGIN,
		}
	},
	userNotLoggedIn() {
		return {
			type: t.USER_NOT_LOGGED_IN_CONFIRM,
		}
	},
	userLoggedIn(jwt) {
		return {
			type: t.USER_IS_LOGGED,
			payload: {
				jwt,
			},
		}
	},
	loginInitialize(locationSearch) {
		return {
			type: t.LOGIN_INITIALIZE,
			locationSearch,
		}
	},
	lmsModalConfirmed() {
		return {
			type: t.LMS_MODAL_CONFIRMED,
		}
	},
	loginSSOErrorConfirmConfirmed() {
		return {
			type: t.LOGIN_SSO_ERROR_CONFIRM_CONFIRMED,
		}
	},
	ssoRedirect(redirectUrl, isInIframe, fromLTI) {
		return {
			type: t.LOGIN_SSO_REDIRECT,
			redirectUrl,
			isInIframe,
			fromLTI,
		}
	},

	ssoRedirectMetricsSuccess(redirectUrl, isInIframe, fromLTI) {
		return {
			type: t.LOGIN_SSO_REDIRECT_METRICS_SUCCESS,
			redirectUrl,
			isInIframe,
			fromLTI,
		}
	},

	onForgotPassword(shouldShowInformation) {
		return {
			type: t.GOOGLE_SLIDES_FORGOT_PASSWORD,
			shouldShowInformation,
		}
	},

	loginFinalize() {
		return {
			type: t.LOGIN_FINALIZE,
		}
	},

	studentGoogleLoginSuccess(tokenData) {
		return {
			type: t.LOGIN_STUDENT_GOOGLE_LOGIN_SUCCESS,
			tokenData,
		}
	},

	studentGoogleLoginFailed(error) {
		return {
			type: t.LOGIN_STUDENT_GOOGLE_LOGIN_FAILED,
			error,
		}
	},

	studentSubmitLoginGoogleTokenSuccess(data) {
		return {
			type: t.LOGIN_STUDENT_SUBMIT_LOGIN_GOOGLE_TOKEN_SUCCESS,
			data,
		}
	},

	studentSubmitLoginGoogleTokenFailed(error) {
		return {
			type: t.LOGIN_STUDENT_SUBMIT_LOGIN_GOOGLE_TOKEN_FAILED,
			error,
		}
	},

	studentOffice365LoginSuccess(tokenData) {
		return {
			type: t.LOGIN_STUDENT_OFFICE_365_LOGIN_SUCCESS,
			tokenData,
		}
	},

	studentOffice365LoginFailed(error) {
		return {
			type: t.LOGIN_STUDENT_OFFICE_365_LOGIN_FAILED,
			error,
		}
	},

	studentSubmitLoginOffice365TokenSuccess(data) {
		return {
			type: t.LOGIN_STUDENT_SUBMIT_LOGIN_OFFICE_365_TOKEN_SUCCESS,
			data,
		}
	},

	studentSubmitLoginOffice365TokenFailed(error) {
		return {
			type: t.LOGIN_STUDENT_SUBMIT_LOGIN_OFFICE_365_TOKEN_FAILED,
			error,
		}
	},
}

export default loginActions
